module.exports = __webpack_public_path__ + "images/emoji/gemini.9364466b94b8d62579b2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/gemini.png
// module id = 3PnT
// module chunks = 1